module.exports = __webpack_public_path__ + "static/img/prestama.5dc9a693.svg";